module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-5-9a7b4da31eaaea865b8c9499d3780095.jpg";